import { useTranslation } from "react-i18next"
import { ArrowLeftIcon } from "@cividao/components"
import styles from "./index.module.css"

interface AuthTopbarProps {
  text: string
  currentStep?: number
  totalSteps?: number
  onBack?: () => void
  rightAction?: React.ReactNode
}

export function AuthTopbar({ text, currentStep, totalSteps, onBack, rightAction }: AuthTopbarProps) {
  const { t } = useTranslation("common")
  const showSteps = currentStep !== undefined && totalSteps !== undefined

  return (
    <div className={styles.topbar}>
      {onBack && (
        <button className={styles.backButton} onClick={onBack} aria-label={t("back")}>
          <ArrowLeftIcon />
        </button>
      )}
      <span className={styles.topbarText}>
        {showSteps && t("stepProgress", { current: currentStep, total: totalSteps })}
        {text}
      </span>
      {rightAction ?? (onBack && <div className={styles.placeholder} />)}
    </div>
  )
}
